var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: { "content-css": { minWidth: "30vw" } },
      model: {
        value: _vm.uploadModal.open,
        callback: function($$v) {
          _vm.$set(_vm.uploadModal, "open", $$v)
        },
        expression: "uploadModal.open"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-icon", { attrs: { name: "cloud upload" } }),
              _c("q-toolbar-title", [
                _vm._v("\n        Upload Document\n      ")
              ]),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    return _vm.onClose($event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-toolbar-title"),
              _c("q-btn", {
                attrs: { label: "Upload", color: "green" },
                on: {
                  click: function($event) {
                    _vm.upload()
                  }
                }
              }),
              _vm._v(" \n      "),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Cancel" },
                nativeOn: {
                  click: function($event) {
                    return _vm.onClose($event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding", attrs: { id: "upload-body" } },
            [
              _c(
                "div",
                [
                  _c("h6", [_vm._v(" Details ")]),
                  _c(
                    "q-field",
                    {
                      staticClass: "q-pa-sm",
                      attrs: {
                        error: _vm.$v.uploadForm.DOCUMENT_NAME.$error,
                        "error-label": "Required"
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": "Document Name",
                          value: _vm.uploadForm.DOCUMENT_NAME
                        },
                        on: {
                          blur: _vm.$v.uploadForm.DOCUMENT_NAME.$touch,
                          keyup: function($event) {
                            $event.stopPropagation()
                            _vm.updateUploadForm({
                              field: "DOCUMENT_NAME",
                              value: $event.target.value
                            })
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.hideEntity
                    ? _c(
                        "q-field",
                        { staticClass: "q-pa-sm" },
                        [
                          _c("q-select", {
                            attrs: {
                              clearable: "",
                              hide: _vm.hideEntity,
                              "float-label": "Entity",
                              value: _vm.uploadForm.LK_ENTITY_ID,
                              options: _vm.entityOptions
                            },
                            on: {
                              change: function(val) {
                                return _vm.updateUploadForm({
                                  field: "LK_ENTITY_ID",
                                  value: val
                                })
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.hideEntity
                    ? _c(
                        "q-field",
                        { staticClass: "q-pa-sm" },
                        [
                          _vm.uploadForm.LK_ENTITY_ID === 1
                            ? _c("user-auto-complete", {
                                attrs: {
                                  hide: _vm.hideEntity,
                                  onSelect: _vm.selectUser,
                                  userId: _vm.uploadForm.ENTITY_ITEM_ID
                                }
                              })
                            : _vm._e(),
                          _vm.uploadForm.LK_ENTITY_ID === 2
                            ? _c("student-auto-complete", {
                                attrs: {
                                  hide: _vm.hideEntity,
                                  onSelect: _vm.selectStudent,
                                  studentId: _vm.uploadForm.ENTITY_ITEM_ID
                                }
                              })
                            : _vm._e(),
                          _vm.uploadForm.LK_ENTITY_ID === 3
                            ? _c("course-auto-complete", {
                                attrs: {
                                  hide: _vm.hideEntity,
                                  onSelect: _vm.selectCourse,
                                  courseId: _vm.uploadForm.ENTITY_ITEM_ID
                                }
                              })
                            : _vm._e(),
                          _vm.uploadForm.LK_ENTITY_ID === 4
                            ? _c("class-auto-complete", {
                                attrs: {
                                  hide: _vm.hideEntity,
                                  onSelect: _vm.selectClass,
                                  classId: _vm.uploadForm.ENTITY_ITEM_ID
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "q-field",
                    {
                      staticClass: "q-pa-sm",
                      attrs: {
                        error: _vm.$v.uploadForm.LK_DOCUMENT_TYPE_ID.$error,
                        "error-label": "Required"
                      }
                    },
                    [
                      _c("q-select", {
                        attrs: {
                          "float-label": "Document Type",
                          value: _vm.uploadForm.LK_DOCUMENT_TYPE_ID,
                          options: _vm.documentTypeOptionsStripped
                        },
                        on: {
                          change: function(val) {
                            return _vm.updateUploadForm({
                              field: "LK_DOCUMENT_TYPE_ID",
                              value: val
                            })
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "q-pt-xl q-px-sm" },
                [
                  _c("h6", [_vm._v(" Select Document ")]),
                  _c(
                    "q-field",
                    {
                      staticClass: "q-pa-sm",
                      attrs: { helper: _vm.fileTypeInfo }
                    },
                    [
                      _c("q-uploader", {
                        ref: "documentUpload",
                        attrs: {
                          "auto-expand": "",
                          "hide-upload-button": "",
                          url: "",
                          method: "PUT",
                          "url-factory": _vm.generateSignedUrl,
                          extensions: _vm.fileExtensions,
                          "send-raw": true
                        },
                        on: { uploaded: _vm.onUploaded, fail: _vm.onFail }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c("info-modal", {
        attrs: {
          isOpen: _vm.showInfoModal,
          closeModal: _vm.closeInfoModal,
          title: "Thanks for uploading",
          body:
            "Thanks for uploading your roster! No need to email your roster to the team. We've got it!"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }